import { get, post, put, remove as httpRemove } from '../Services/http';
import { catchError } from './Error.action';

export const ADDRESS_RECEIVE = 'ADDRESS_RECEIVE';
export const ADDRESS_ERROR = 'ADDRESS_ERROR';
export const ADDRESS_CHANGE_MODE = 'ADDRESS_CHANGE_MODE';
export const ADDRESS_SORT = 'ADDRESS_SORT';

const rootRoute = '/api/mypageaddress';

export const changeMode = mode => ({
    type: ADDRESS_CHANGE_MODE,
    payload: {
        mode,
    }
})

export const sortAddresses = (id) => (dispatch) => {
    var queryData = "";
    var sortById = document.getElementById('addressSortById');
    var sortByName = document.getElementById('addressSortByName');
    var isSorted = "True";
    if (id === "Id") {
        sortById.classList.toggle('sorted');
        if (sortById.classList.contains("sorted")) {
            queryData = id + "," + isSorted;
        } else {
            queryData = id + "," + "";
        }
    } else {
        sortByName.classList.toggle('sorted');
        if (sortByName.classList.contains("sorted")) {
            queryData = id + "," + isSorted;
        } else {
            queryData = id + "," + "";
        }
    }
    

    return post(rootRoute + '/sortAddresses', queryData)
        .then(response => response.json())
        .then(result => {
            dispatch(receive(result, "list"));
        })
        .catch(ex => dispatch(catchError(ex, error => setError(error))))
        ;
}

export const query = (mode = 'list') => (dispatch) => {
    return get(rootRoute)
        .then(response => response.json())
        .then(result => {
            dispatch(receive(result, mode));
        })
        .catch(ex => dispatch(catchError(ex, error => setError(error))))
        ;
}

export const remove = (addressSystemId) => (dispatch) =>
    httpRemove(rootRoute, addressSystemId)
        .then(() => dispatch(query()))
        .catch(ex => dispatch(catchError(ex, error => setError(error))))
    ;

export const add = (address) => (dispatch) =>
    post(rootRoute, address)
        .then(() => dispatch(query()))
        .catch(ex => dispatch(catchError(ex, error => setError(error))))
    ;

export const edit = (address) => (dispatch) =>
    put(rootRoute, address)
        .then(() => dispatch(query()))
        .catch(ex => dispatch(catchError(ex, error => setError(error))))
    ;

const receive = (list, mode) => ({
    type: ADDRESS_RECEIVE,
    payload: {
        list,
        mode,
    },
})

export const setError = error => ({
    type: ADDRESS_ERROR,
    payload: {
        error,
    },
})